import moment from 'moment-timezone';

export function canCloseSeasonEvent(event, now = moment()) {
    if (!event?.parent_event_id || Number(event.seats_flag) !== 1 || event.seats_closed_at) {
        return false;
    }
    if (!event.end_date || !moment.tz.zone(event.time_zone)) return false;
    const end = moment.tz(event.end_date, event.time_zone);
    return end.isValid() && now.isAfter(end.add(2, 'hours'));
}
